/**
 * Undo toast text: "Change undone" when the whole action is reversible. When
 * {@link Project.effectsOutsideUndo} contains effects that survive the undo,
 * report a partial undo and identify each remaining effect. Redo never warns:
 * such effects were never reverted, so replaying the project change is complete.
 */
export const composeUndoneMessage = (
  effectsOutsideUndo: readonly string[] | undefined,
): string => {
  const warnings = (effectsOutsideUndo ?? []).map(
    (label) => `${label} could not be undone.`,
  );
  return warnings.length === 0
    ? 'Change undone'
    : `Change partially undone. ${warnings.join(' ')}`;
};

/**
 * Redo toast text after a change has been applied again.
 */
export const composeRedoneMessage = (): string => 'Change reapplied';
